<div class="d-flex flex-column flex-root">
  <div class="page d-flex flex-row flex-column-fluid">
    <app-aside
      id="kt_aside"
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle"
      class="aside"
      [ngClass]="asideCSSClasses"
      [class.d-none]="pageInfoService.isOutOfContext$ | async"
    ></app-aside>
    <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
      <app-header
        id="kt_header"
        [ngClass]="headerCSSClasses"
        class="header align-items-stretch"
        #ktHeader
      ></app-header>
      <div id="kt_content" class="content d-flex flex-column flex-column-fluid">
        <div class="post" id="kt_post">
          <app-content></app-content>
        </div>
      </div>
    </div>
  </div>
</div>

<app-scripts-init></app-scripts-init>
<app-scroll-top></app-scroll-top>

<!-- begin:: Drawers -->
<!--<app-chosen-offers></app-chosen-offers>-->
<!-- end:: Drawers -->

<!-- begin:: Modals -->
<app-main-modal></app-main-modal>
<app-invite-users-modal></app-invite-users-modal>
<app-upgrade-plan-modal></app-upgrade-plan-modal>
<!-- end:: Modals -->

<!-- ToDo: fix app to be able to use ComponentsModule in AppModule -->
<app-overlay-loader
  *ngIf="logoutOngoing$ | async"
  class="position-fixed w-100 h-100 top-0 start-0"
  style="z-index:10000"
></app-overlay-loader>
